<template>
    <base-page>
        <el-card style="margin: 1px 0px 1px 0px">
            <el-collapse accordion style="border: none;padding:0px">
                <el-collapse-item name="1" style="border: none;  ">
                    <template slot="title">
                        <div slot="header" class="clearfix">
                            <titlu-pagina Titlu="Programari" @on_add_clicked="show_dialog()" :AdaugaVisible="false" />
                        </div>
                    </template>
                    <div class="filtre">
                        <el-row :gutter="5">
                            <el-form :inline="true" label-position="top" width="100%"
                                @submit.prevent.native='refresh_info()'>
                                <el-col class="input-element" :md="2" :sm="12" :xs="12">
                                    <el-form-item label="# progr." size="mini" class='full-width'>
                                        <el-input v-model="Filters.IdProgramare" class='full-width'
                                            @input="handle_id_programare_change()" size="mini" clearable />
                                    </el-form-item>
                                </el-col>
                                <el-col class="input-element" :md="2" :sm="12" :xs="12">
                                    <el-form-item label="Nr auto" size="mini" class='full-width'>
                                        <el-input v-model="Filters.Numar" @input="refresh_info()" class='full-width'
                                            size="mini" clearable />
                                    </el-form-item>
                                </el-col>


                                <el-col class="input-element" :md="2" :sm="12" :xs="12">
                                    <el-form-item label="Marca" size="mini" class='full-width'>
                                        <el-select v-model="Filters.Marca" @change="marcaChangeHandler()" class="full-width"
                                            filterable size="mini" clearable>
                                            <el-option label="Toate" value="-1" />
                                            <el-option v-for="item in Info.marci" :key="'marci' + item.Id"
                                                :label="item.Nume" :value="item.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col class="input-element" :md="2" :sm="12" :xs="12">
                                    <el-form-item label="Model" size="mini" class='full-width'>
                                        <el-select v-model="Filters.Model" @change="refresh_info" class="full-width"
                                            filterable size="mini" clearable
                                            :disabled="Filters.Marca == -1 || Filters.Marca == '' || !Filters.Marca">
                                            <el-option label="Toate" value="-1" />
                                            <el-option v-for="item in Info.modele" :key="'modele' + item.Id"
                                                :label="item.Nume" :value="item.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>



                                <el-col class="input-element" :md="2" :sm="12" :xs="12">
                                    <el-form-item label="Telefon" size="mini" class='full-width'>
                                        <el-input v-model="Filters.Telefon" class='full-width'
                                            @input="handle_telefon_change()" size="mini" clearable />
                                    </el-form-item>
                                </el-col>
                                <el-col class="input-element" :md="3" :sm="12" :xs="12">
                                    <el-form-item label="Utiliz. (client)" size="mini" class='full-width'>
                                        <el-select class="full-width" v-model="Filters.IdClient" @change="refresh_info"
                                            filterable remote reserve-keyword placeholder="Search for client"
                                            :remote-method="searchClients" :loading="loadingClients" size="mini"
                                            clearable>
                                            <el-option v-for="item in Info.clienti" :key="'clienti' + item.Id"
                                                :label="item.Nume + ' ' + item.Prenume" :value="item.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col class="input-element" :md="3" :sm="12" :xs="12">
                                    <el-form-item label="Interval orar" size="mini" class='full-width'>
                                        <el-time-picker size="mini" clearable value-format="HH:mm:00" class="full-width"
                                            format="HH:mm" is-range @change="refresh_info()"
                                            v-model="Filters.IntervalOrar" range-separator="-" start-placeholder="De la"
                                            end-placeholder="Pana la">
                                        </el-time-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col class="input-element" :md="2" :sm="12" :xs="12">
                                    <el-form-item label='C. prod' size="mini" class='full-width'>
                                        <el-select class='full-width' v-model='Filters.IdCentruProductie' filterable
                                            @change="refresh_info" size="mini">
                                            <!-- <el-option label='Toti' value='-1'></el-option> -->
                                            <el-option v-for='item in Info.centreProductie' :key="'centre' + item.Id"
                                                :label='item.Nume' :value='item.Id' />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col class="input-element" :md="2" :sm="12" :xs="12">
                                    <el-form-item label="Status" size="mini" class='full-width'>
                                        <el-select v-model="Filters.Status" @change="refresh_info" class="full-width"
                                            filterable size="mini">
                                            <el-option label="Toate" value="-1" />
                                            <el-option label="Deschise" value="Deschisa" />
                                            <el-option label="In lucru" value="Draft" />
                                            <el-option label="Nefacturate" value="Nefacturat" />
                                            <el-option label="Facturate" value="Facturat" />
                                            <el-option label="Anulate" value="Anulata" />
                                            <el-option label="Lipsa operatiune" value="Lipsa operatiune" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col class="input-element" :md="2" :sm="12" :xs="12">
                                    <el-form-item label='Mecanic' size="mini" class='full-width'>
                                        <el-select class='full-width' @change="refresh_info" v-model='Filters.IdMecanic'
                                            filterable size="mini">
                                            <el-option label='Toti' value='-1' />
                                            <el-option v-for='item in Info.mecanici' :key="'utilizatori' + item.Id"
                                                :label='item.Nume' :value='item.Id' />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col class="input-element" :md="2" :sm="12" :xs="12">
                                    <el-form-item label='Hotel' size="mini" class='full-width'>
                                        <el-select class='full-width' @change="refresh_info" v-model='Filters.Hotel'
                                            filterable size="mini">
                                            <el-option label='Toate' value='-1' />
                                            <el-option label='Hotel' value='1' />
                                            <el-option label='NON-Hotel' value='0' />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col class="input-element" :span="24">
                                    <el-button @click='reset' size="mini"> Reset </el-button>
                                </el-col>
                            </el-form>
                        </el-row>

                    </div>
                </el-collapse-item>
            </el-collapse>
        </el-card>
        <!-- 
        <span v-if="this.Results.length > 0" >{{this.Results[0]}}</span>
        <span v-else >nu e frate</span> -->

        <el-card style="margin:1px 0px 1px 0px; padding:10px; min-height: 100vh;" v-loading="loadingCalendar">
            <Calendar :Programari.sync="Results" @programareNoua='programareNoua' @editProgramare='editProgramare'
                @handleIntervalChange="handleIntervalChange" />
        </el-card>
        <el-dialog :title="selectedObject.Id > 0 ? 'Programare #' + selectedObject.Id : 'Programare noua'"
            :visible.sync="showPopup" width="80%" :fullscreen="true" append-to-body>
            <el-card v-if="arataInfoMasina" style="margin:5px 0px 5px 0px; padding:10px;">
                <p> Masina selectata:</p>
                <p> <strong>{{ detaliiMasina.MarcaNume }} {{ detaliiMasina.ModelNume }} </strong><span
                        v-if="detaliiMasina.An > 0">
                        An:
                        <strong>{{ detaliiMasina.An }}</strong></span> Tip: <strong>{{ detaliiMasina.TipAuto }}
                    </strong>
                    <span v-if="mode == 'add' || selectedObject.IdDeviz == null || selectedObject.AcordSemnat == false"
                        class="buton-link" @click="modificaMasina"> modifica</span>
                </p>
                <p> Client: <strong>{{ detaliiMasina.NumeClient }}</strong> Telefon:
                    <strong>{{ detaliiMasina.Telefon }}</strong>
                    Email: <strong>{{ detaliiMasina.Email }}</strong>
                    <span circle
                        v-if="mode == 'add' || selectedObject.IdDeviz == null || selectedObject.AcordSemnat == false"
                        class="buton-link" @click="modificaClient"> modifica</span>
                </p>
            </el-card>
            <el-form class="input-group-big" label-position="top" :inline="false" label-width="100%"
                :model='selectedObject' ref='my-form' v-loading="loading" :rules='rules'>
                <el-row :gutter="15">
                    <el-col class="input-prog">
                        <el-form-item label='Masina' prop="IdMasina">
                            <div class="input-group">
                                <SelectMasina v-model="numarMasina" :NumarMasina="numarMasina"
                                    :IdMasina.sync="selectedObject.IdMasina" @selectie="select_masina"
                                    class="input-group-input" :Dezactivat="selectedObject.Status == 'Anulata'" />
                                <div class="input-group-append"><el-button plain type="success" icon="el-icon-plus"
                                        @click="adaugaMasina" :disabled="this.selectedObject.Status == 'Anulata'" />
                                </div>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col class="input-prog">
                        <el-form-item label='Mecanic' prop="IdMecanic">
                            <el-select v-model='selectedObject.IdMecanic' @change="getSloturiDisponibile()"
                                class='full-width' filterable :disabled="this.selectedObject.Status == 'Anulata'">
                                <el-option label='Oricare' value='-1' />
                                <el-option v-for='item in Info.mecaniciCentru' :key="'utilizatori' + item.IdUtilizator"
                                    :label='item.Nume' :value='item.IdUtilizator' />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="mode != 'add'" class="input-prog">
                        <el-form-item v-if="selectedObject.includeAjutorMontator == 1" label="Ajutor" prop="Ajutor">
                            <el-select v-model="selectedObject.IdAjutorMontator"
                                    class="full-width"
                                    :disabled="selectedObject.hasDeviz"
                                    filterable>
                            <el-option v-if="selectedObject.IdAjutorMontator == -99" label="Ajutorul de montator nu a fost ales" value="-99"></el-option>
                            <el-option label="Fara ajutor" value="-1"></el-option>
                            <el-option v-for="item in Info.ajutor_mecanici"
                                        :key="'utilizatori_ajutor' + item.Id"
                                        :label="item.Nume"
                                        :value="item.Id" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col class="input-prog">
                        <el-form-item label='Serviciu programator' prop="IdServiciuProgramator">
                            <el-select v-model='selectedObject.IdServiciuProgramator' @change="handleChangeCantitate()"
                                class='full-width' filterable :disabled="this.selectedObject.Status == 'Anulata'">
                                <el-option v-for='item in Info.serviciiProgramator'
                                    :key="'serviciiProgramator' + item.Id" :label='item.Nume' :value='item.Id' />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col class="input-prog">
                        <el-form-item label='Cantitate' prop="Cantitate">
                            <el-input-number :clearable='false' @change="handleChangeCantitate()" class='full-width'
                                v-model='selectedObject.Cantitate' :min="1" :max="8"
                                :disabled="this.selectedObject.Status == 'Anulata'" />
                        </el-form-item>
                    </el-col>

                    <el-col class="input-prog">
                        <el-form-item label='Durata (minute)' prop="DurataMin">
                            <el-input-number v-model="selectedObject.DurataMin" @change="getSloturiDisponibile()"
                                class="full-width" :precision="0" :min="5" :max="999"
                                :disabled="this.selectedObject.Status == 'Anulata'" />
                            <!-- :step="5" step-strictly -->
                        </el-form-item>
                    </el-col>

                    <el-col v-if="new Date(selectedObject.DataRezervarii) < new Date().setHours(0, 0, 0, 0)"
                        class="input-prog">
                        <el-form-item label='Data programare' prop="DataRezervarii">
                            <el-date-picker disabled :clearable='false' :picker-options="datePickerOptions"
                                class='full-width' v-model='selectedObject.DataRezervarii' type='datetime'
                                value-format='yyyy-MM-dd HH:mm:ss' format='dd.MM.yyyy HH:mm' />
                        </el-form-item>
                    </el-col>

                    <el-col
                        v-if="new Date(selectedObject.ZiuaRezervarii) >= new Date().setHours(0, 0, 0, 0) || this.mode == 'add'"
                        class="input-prog">
                        <el-form-item label='Ziua' prop="ZiuaRezervarii">
                            <el-date-picker :clearable='false' :picker-options="datePickerOptions" class='full-width'
                                v-model='selectedObject.ZiuaRezervarii' type='date' value-format='yyyy-MM-dd'
                                format='dd.MM.yyyy' @input="handleSchimbaZiua" />
                        </el-form-item>
                    </el-col>

                    <el-col class="input-prog" v-if="OptiuneCantitati == 'cantitate_bifa_hotel'">
                        <el-form-item label='Hotel'>
                            <el-checkbox :disabled="true" v-model="selectedObject.Hotel" :true-label="1" :false-label="0"
                                border class='full-width'>Hotel</el-checkbox>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row v-if="OptiuneCantitati == 'sursa_destinatie'" :gutter="15">
                    <el-col :md="12" :sm="24">
                        <el-card>
                            <template #header>
                                <div>
                                    <span>Sursa anvelope</span>
                                </div>
                            </template>
                            <el-form label-position="top">
                                <el-row :gutter="15">
                                    <el-col :md="8" :sm="24">
                                        <el-form-item label="Depozitare personala">
                                            <el-input-number style="width:100%" :min="0" v-model="DepozitarePersonala" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :md="8" :sm="24">
                                        <el-form-item label="Comanda">
                                            <el-input-number style="width:100%" :min="0" v-model="DepozitareComanda" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :md="8" :sm="24">
                                        <el-form-item label="Hotel">
                                            <el-input-number style="width:100%" :min="0" v-model="DepozitareHotel" @change="verifica_hotel()"/>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-card>
                    </el-col>
                    <el-col :md="12" :sm="24">
                        <el-card>
                            <template #header>
                                <div>
                                    <span>Destinatie anvelope</span>
                                </div>
                            </template>
                            <el-form label-position="top">
                                <el-row :gutter="15">
                                    <el-col :md="8" :sm="24">
                                        <el-form-item label="Reciclare">
                                            <el-input-number style="width:100%" :min="0" v-model="Reconditionare" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :md="8" :sm="24">
                                        <el-form-item label="Hotel">
                                            <el-input-number style="width:100%" :min="0" v-model="Hotel"/>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :md="8" :sm="24">
                                        <el-form-item label="Returnare">
                                            <el-input-number style="width:100%" :min="0" v-model="Returnare" />
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row v-if="DepozitareComanda && DepozitareComanda > 0 && (this.mode == 'add' || (selectedObject.IdDeviz == null || selectedObject.AcordSemnat == false) && this.selectedObject.Status != 'Anulata')" :gutter="15">
                    <el-card style="margin:5px 0; padding:10px;">
                        <template #header>
                            <div>
                                <span>Numere comandă</span>
                            </div>
                        </template>
                        <div class="flex gap-2 flex-wrap">
                            <el-tag
                                style="cursor: pointer;"
                                v-for="(tag, index) in selectedObject.NumereComanda"
                                :key="index"
                                closable
                                @input="inputNumarComanda(tag)"
                                @close="removeNumarComanda(tag)"
                                @click="goToOrder(tag)">
                                {{ tag }}
                            </el-tag>
                            <el-input
                                v-if="tagInputVisible"
                                v-model="tagInputValue"
                                class="w-24"
                                size="small"
                                @keyup.enter.native="handleTagInputConfirm"
                                @blur="handleTagInputConfirm"
                            />
                            <el-button
                                v-else
                                class="button-new-tag"
                                size="small"
                                @click="showTagInput"
                            >
                            + Numar nou
                            </el-button>
                        </div>
                        </el-card>
                </el-row>
                <el-row :gutter="15">
                    <el-col>
                        <!-- {{this.selectedObject.ZiLiberaSauLipsaProgram}} -->
                        <el-card v-if="(typeof selectedObject.suprapune != 'undefined' || typeof selectedObject.ZiLiberaSauLipsaProgram != 'undefined')
                            && selectedObject.DataRezervariiInitiala == selectedObject.ZiuaRezervarii + ' ' + selectedObject.OraSelectata + ':00'
                            && selectedObject.IdMecanic == selectedObject.IdMecanicInitial
                        " style="margin:5px 0px 5px 0px; padding:10px; color:red !important;">
                            {{ this.selectedObject.suprapune }} {{ this.selectedObject.ZiLiberaSauLipsaProgram }}
                        </el-card>

                        <div class="ore"
                            v-if="this.Info.OreZi != undefined && this.selectedObject.Status != 'Anulata' && this.selectedObject.ZiuaRezervarii != null && this.selectedObject.ZiuaRezervarii.length > 0"
                            :key="refresh">
                            <p><span class="bara">Alege ora programarii pentru <span class="data">{{
                                selectedObject.ZiuaRezervarii | DataRo }}</span></span></p>
                            <div class="butoane">
                                <div v-for="(value, index) of this.Info.OreZi" :key="'ora' + index" :class="value.liber ?
                                    selectedObject.OraSelectata == index ? 'ora-selectata' : 'liber'
                                    : selectedObject.OraSelectata == index ? 'ora-selectata-ocupata' : 'ocupat'
                                    " @click="select_hour(value, index)">
                                    {{ index }}
                                </div>
                            </div>
                            <div v-if="this.Info.OreZi.length == 0"> nu exista disponibilitate </div>
                        </div>
                        <div v-else-if="this.selectedObject.Status != 'Anulata'" class="ore">
                            <p><span class="bara">Alege o zi</span></p>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="15">
                    <el-col>
                        <el-form-item label='Observatii' prop="Observatii">
                            <el-input type="textarea" :rows="2" placeholder="Observatii"
                                v-model="selectedObject.Observatii"
                                :disabled="this.selectedObject.Status == 'Anulata'" />
                        </el-form-item>
                        <el-button
                            v-if="mode == 'edit' && this.selectedObject.ObservatiiInitiale != this.selectedObject.Observatii"
                            type="link" size="small" @click="schimba_observatiile()"> Salveaza observatiile </el-button>

                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">

                <el-button v-if="mode == 'edit' && this.selectedObject.Status != 'Anulata'" @click="adauga_produse()"
                    style="background-color: rgb(148, 57, 72); color: white;"> Adauga produse </el-button>
                <el-button v-if="mode == 'edit' && this.selectedObject.Status != 'Anulata'" type="warning"
                    @click="get_mecanici_disponibili()"> Schimba mecanic </el-button>
                <el-button v-if="mode == 'edit' && selectedObject.Status == 'Deschisa' && selectedObject.Hotel == 0"
                    type="info" @click="notifica_depozitare()"> Tichet hotel </el-button>
                <el-button v-if="mode == 'edit'
                    && (selectedObject.IdDeviz == null || selectedObject.AcordSemnat == false)
                    && this.selectedObject.Status != 'Anulata'
                    && (this.$has_right('Management') || this.$has_right('Receptie'))
                    && checkDreptFisa()
                " type="success" @click="verifica_montator_apoi_fisa()"> Acord client </el-button>
                <el-button v-if="mode == 'edit' && selectedObject.IdDeviz != null && selectedObject.AcordSemnat == true"
                    type="success" @click="generare_pdf(selectedObject.IdDeviz)"> Print consimtamant</el-button>

                <el-button
                    v-if="(this.$has_right('Management') || this.$has_right('Receptie')) && mode == 'edit' && (selectedObject.IdDeviz == null || selectedObject.AcordSemnat == false) && this.selectedObject.Status != 'Anulata'"
                    type="danger" @click="delete_item()">Anuleaza</el-button>
                <el-button @click="showPopup = false"> Renunta </el-button>
                <el-button
                    v-if="mode == 'add' || (selectedObject.IdDeviz == null || selectedObject.AcordSemnat == false) && this.selectedObject.Status != 'Anulata'"
                    type="primary" @click="save('my-form')"> Salveaza </el-button>

            </span>
            <!-- <el-card v-if="raspuns.Success == 0 && raspuns.Error" style='margin:5px 0px 5px 0px; padding:10px'>
                Programarea se suprapune cu alte programari, cu programul de lucru, cu pauza mecanicilor sau cu zi libera!    
            </el-card> -->
            <el-card v-if="raspuns.Error" style="margin:5px 0px 5px 0px; padding:10px; color: red;">
                {{ this.raspuns.Error }}
            </el-card>
            <ConfirmareSemnaturaFisa ref="confirmareSemnatura" :destinatieObj="prepareDestinatieAnvelope()"
                @semnat="closeMe" @nesemnat="neSemnat()" />
            <el-dialog :title="selectedObject.includeAjutorMontator == 1 ? 'Schimbă mecanic / ajutor montator' : 'Schimbă mecanic'" :visible.sync="showPopupSchimbaMecanic" width="80%" append-to-body>
                <el-tooltip placement="bottom-end" effect="light">
                    <div slot="content">Arata lista mecanicilor activi.<br />Disponibilitatea este in functie de alte
                        programari, program, pauza sau zile libere.<br />Chiar daca se alege un mecanic indisponibil,
                        acesta va
                        fi alocat aceste programari!</div>
                    <i class="el-icon-info" style="font-size: 17px;color:#409EFF"></i>
                </el-tooltip>
                Mecanic:
                <el-select v-model='IdMecanicNou' class='full-width' filterable
                    placeholder="Alege un mecanic din lista - daca nu se alege nimic, se va pastra mecanicul initial">
                    <el-option v-for='item in Info.mecaniciCentruDisponibili' :key="'utilizatori' + item.IdUtilizator"
                        :label='item.Nume' :value='item.IdUtilizator' />
                </el-select>
                <br />
                <span v-if="selectedObject.includeAjutorMontator == 1">Ajutor Montator:</span>
                <el-select v-if="selectedObject.includeAjutorMontator == 1" v-model='IdMontatorNou' class='full-width' filterable
                    placeholder="Alege un ajutor montator din lista - daca nu se alege nimic, se va pastra cel initial">
                    <el-option label="Fara ajutor" value="-1"></el-option>
                    <el-option v-for='item in Info.montatori' :key="'utilizatori_montatori' + item.Id"
                        :label='item.Nume' :value='item.Id' />
                </el-select>
                <span slot="footer" class="dialog-footer">
                    <el-button :disabled="this.IdMecanicNou == '' && this.IdMontatorNou=='' " type="danger" @click="schimba_mecanic()">
                        Schimba</el-button>
                </span>
            </el-dialog>

        </el-dialog>
        <el-dialog class="dialog-info"
            :title="selectedObject.Id > 0 ? 'Programare #' + selectedObject.Id : 'Programare noua'"
            :visible.sync="showInfoPopup" width="70%" style="height:100vh !important" :fullscreen="false">


            <div class="main-container">
                <div class="half-container">
                    <el-card shadow="hover"
                        style="margin:0px 0px 5px 0px; padding:0px; width: 100%; height: 100% !important; ">
                        <template #header>
                            <div
                                style="display: flex; justify-content: space-between; align-items: center; padding: 0px; height:20px;">
                                <span>Deviz</span>
                                <el-tooltip placement="bottom-end" effect="light">
                                    <div slot="content">Anumite date de la client si masina se salveza direct in deviz.
                                        <br />Acestea nu se schimba in deviz chiar daca se modifica ulterior in tabela
                                        de clienti sau masini.
                                    </div>
                                    <i class="" style="font-size: 23px;color:#409EFF">*</i>
                                </el-tooltip>

                                <!-- <el-button class="button" text @click="modificaClient" size="mini">Modifica</el-button> -->
                            </div>
                        </template>
                        <div style="margin-bottom: 0px">
                            <div v-if="typeof selectedObject.Deviz != 'undefined'">
                                <p class="rand-info">Numar deviz: <strong>{{ selectedObject.Deviz.Id }}</strong></p>
                                <p class="rand-info">Data preluare in lucru:
                                    <strong>{{ selectedObject.Deviz.DataPreluareInLucru
                                        | DataOraFaraSec }}</strong>
                                </p>
                                <p class="rand-info">Data terminare lucru:
                                    <strong>{{ selectedObject.Deviz.DataTerminareLucru |
                                        DataOraFaraSec }}</strong>
                                </p>
                                <p class="rand-info">Data facturare: <strong>{{ selectedObject.Deviz.DataFacturare |
                                    DataOraFaraSec }}</strong></p>
                                <p class="rand-info">Data aprobare: <strong>{{ selectedObject.Deviz.DataAprobare |
                                    DataOraFaraSec }}</strong></p>
                                <p class="rand-info">Utilizator aprobare:
                                    <strong>{{ selectedObject.Deviz.NumeUtilizatorAprobare }}</strong>
                                </p>
                                <p class="rand-info">Data deschiderii: <strong>{{ selectedObject.Deviz.DataDeschiderii |
                                    DataOraFaraSec }}</strong></p>
                                <p class="rand-info">Data inchiderii: <strong>{{ selectedObject.Deviz.DataInchiderii |
                                    DataOraFaraSec }}</strong></p>
                                <p class="rand-info">Data rezervarii:
                                    <strong>{{ selectedObject.Deviz.DataRezervariiInitiala |
                                        DataOraFaraSec }}</strong>
                                </p>
                                <p class="rand-info">Nume si prenume client: <strong>{{ selectedObject.Deviz.NumeClient
                                        }}
                                        {{ selectedObject.Deviz.PrenumeClient }}</strong>*</p>
                                <p class="rand-info">Telefon client:
                                    <strong>{{ selectedObject.Deviz.TelefonClient }}</strong>*
                                </p>
                                <p class="rand-info">Email client:
                                    <strong>{{ selectedObject.Deviz.EmailClient }}</strong>*
                                </p>
                                <p class="rand-info">Id client Evio:
                                    <strong>{{ selectedObject.Deviz.IdClientEvio }}</strong>*
                                </p>
                                <p class="rand-info">Numar auto: <strong>{{ selectedObject.Deviz.Numar }}</strong>*</p>
                                <p class="rand-info">Marca - model auto: <strong>{{ selectedObject.Deviz.MarcaNume }} -
                                        {{ selectedObject.Deviz.ModelNume }}</strong>*</p>
                                <p class="rand-info">An auto: <strong>{{ selectedObject.Deviz.An }}</strong>*</p>
                                <p class="rand-info">Tip auto: <strong>{{ selectedObject.Deviz.TipAuto }}</strong>*</p>
                                <p class="rand-info">Antifurt: <strong>{{ selectedObject.Deviz.Antifurt | DaNu
                                        }}</strong>
                                </p>
                                <p class="rand-info">Sters: <strong>{{ selectedObject.Deviz.Sters | DaNu }}</strong></p>
                                <p class="rand-info">Motiv stergere sau inchidere:
                                    <strong>{{ selectedObject.Deviz.MotivStergere }}</strong>
                                </p>
                                <p class="rand-info">Cuplu (fata): <strong>{{ selectedObject.Deviz.Cuplu }}</strong></p>
                                <p class="rand-info">Cuplu (spate): <strong>{{ selectedObject.Deviz.CupluSpate != null
                                    &&
                                    selectedObject.Deviz.CupluSpate !== '' ? selectedObject.Deviz.CupluSpate :
                                    selectedObject.Deviz.Cuplu }}</strong></p>
                                <p class="rand-info">Presiune roti fata: <strong>{{ selectedObject.Deviz.PresiuneRoti
                                }}</strong>
                                </p>
                                <p class="rand-info">Presiune roti spate:
                                    <strong>{{ selectedObject.Deviz.PresiuneRotiSpate
                                    }}</strong>
                                </p>
                                <p class="rand-info">Status deviz: <strong>{{ selectedObject.Deviz.Status }}</strong>
                                </p>
                                <p class="rand-info">Observatii: <strong>{{ selectedObject.Deviz.Observatii }}</strong>
                                </p>
                                <p class="rand-info">Nume mecanic: <strong>{{ selectedObject.Deviz.NumeMecanic
                                        }}</strong>
                                </p>
                                <p class="rand-info">Tip anvelope: <strong>{{ selectedObject.Deviz.TipAnvelope
                                        }}</strong>
                                </p>
                                <el-table v-if="selectedObject.Deviz.StareRoti != null && jantaAvariata"
                                    :data="(selectedObject.Deviz.StareRoti ? JSON.parse(selectedObject.Deviz.StareRoti).filter((item) => item.index >= 0) : [])"
                                    size="mini" class="tabelRandMic">
                                    <el-table-column label="Roata" width="60x" align="center">
                                        <template slot-scope="scope">
                                            {{ Number(scope.row.index) + 1 }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Verificata" width="80x" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.verificata | DaNu }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Aspect janta" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.starea_jantei }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Janta avariata" width="110x" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.janta_avariata | DaNu }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Stare anvelopa" width="110x" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.starea_anvelopei && scope.row.starea_anvelopei !== '' ?
                                                scope.row.starea_anvelopei : '-' }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Diametru initial" width="110x" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.diametru_initial && scope.row.diametru_initial !== '' ?
                                                scope.row.diametru_initial : '-' }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Diametru final" width="110x" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.diametru_final && scope.row.diametru_final !== '' ?
                                                scope.row.diametru_final : '-' }}
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-table v-else
                                    :data="(selectedObject.Deviz.StareRoti ? JSON.parse(selectedObject.Deviz.StareRoti).filter((item) => item.index >= 0) : [])"
                                    size="mini" class="tabelRandMic">
                                    <el-table-column label="Roata" width="60x" align="center">
                                        <template slot-scope="scope">
                                            {{ Number(scope.row.index) + 1 }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Verificata" width="80x" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.verificata | DaNu }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Aspect janta" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.starea_jantei }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Deformare janta" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.deformari_jante }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Stare anvelopa" width="110x" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.starea_anvelopei && scope.row.starea_anvelopei !== '' ?
                                                scope.row.starea_anvelopei : '-' }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Diametru initial" width="110x" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.diametru_initial && scope.row.diametru_initial !== '' ?
                                                scope.row.diametru_initial : '-' }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Diametru final" width="110x" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.diametru_final && scope.row.diametru_final !== '' ?
                                                scope.row.diametru_final : '-' }}
                                        </template>
                                    </el-table-column>
                                </el-table>

                            </div>
                        </div>
                    </el-card>
                </div>
                <div class="half-container">
                    <el-card shadow="hover" style="margin:0px 0px 5px 0px; padding:0px; width: 100%;">
                        <template #header>
                            <div
                                style="display: flex; justify-content: space-between; align-items: center; padding: 0px">
                                <span>Masina</span>
                                <!-- <el-button class="button" text @click="modificaMasina" size="mini">Modifica</el-button> -->
                            </div>
                        </template>
                        <div style="margin-bottom: 0px">
                            <p class="rand-info">Numar: <strong>{{ detaliiMasina.Numar }}</strong></p>
                            <p class="rand-info">Marca: <strong>{{ detaliiMasina.MarcaNume }}</strong></p>
                            <p class="rand-info">Model: <strong>{{ detaliiMasina.ModelNume }}</strong></p>
                            <p class="rand-info">An: <strong>{{ detaliiMasina.An }}</strong></p>
                            <p class="rand-info">Km: <strong>{{ detaliiMasina.Km }}</strong></p>
                            <p class="rand-info">Tip auto: <strong>{{ detaliiMasina.TipAuto }}</strong></p>
                        </div>
                    </el-card>
                    <el-card shadow="hover" style="margin:2px 0px 5px 0px; padding:0px; width: 100%;">
                        <template #header>
                            <div
                                style="display: flex; justify-content: space-between; align-items: center; padding: 0px">
                                <span>Client</span>
                                <!-- <el-button class="button" text @click="modificaClient" size="mini">Modifica</el-button> -->
                            </div>
                        </template>
                        <div style="margin-bottom: 0px">
                            <div v-if="typeof selectedObject.client != 'undefined'">
                                <p class="rand-info">Nume: <strong>{{ selectedObject.client.Nume }}</strong></p>
                                <p class="rand-info">Prenume: <strong>{{ selectedObject.client.Prenume }}</strong></p>
                                <p class="rand-info">Email: <strong>{{ selectedObject.client.Email }}</strong></p>
                                <p class="rand-info">Telefon: <strong>{{ selectedObject.client.Telefon }}</strong></p>
                            </div>
                        </div>
                    </el-card>
                    <el-card shadow="hover" style="margin:2px 0px 5px 0px; padding:0px; width: 100%;">
                        <template #header>
                            <div
                                style="display: flex; justify-content: space-between; align-items: center; padding: 0px">
                                <span>Programare</span>
                                <el-button type="warning" class="button" text @click="reprogrameaza()"
                                    size="mini">Reprogrameaza</el-button>
                            </div>
                        </template>
                        <div style="margin-bottom: 0px">
                            <p class="rand-info">Numar programare: <strong>{{ selectedObject.Id }}</strong></p>
                            <p class="rand-info">Status rezervare: <strong>{{ selectedObject.Status }}</strong></p>
                            <p class="rand-info">Centru productie:
                                <strong>{{ selectedObject.NumeCentruProductie }}</strong>
                            </p>
                            <p class="rand-info">Serviciu programator:
                                <strong>{{ selectedObject.NumeServiciuProgramator }}</strong>
                            </p>
                            <p class="rand-info">Data rezervarii: <strong>{{ selectedObject.DataRezervariiInitiala |
                                DataOraFaraSec }}</strong></p>
                            <p class="rand-info">Cantitate: <strong>{{ selectedObject.Cantitate }}</strong></p>
                            <p class="rand-info">Durata: <strong>{{ selectedObject.DurataMin }}</strong> minute</p>
                            <p class="rand-info">Hotel: <strong>{{ selectedObject.Hotel | DaNu }}</strong></p>
                            <p class="rand-info">Observatii: <strong>{{ selectedObject.Observatii }}</strong></p>
                            <p class="rand-info">Data adaugare rezervare: <strong>{{ selectedObject.DataAdaugare |
                                DataOraFaraSec }}</strong></p>
                            <p class="rand-info">Anulata de: <strong>{{ selectedObject.Anulata }}</strong></p>
                            <p class="rand-info">Data anulare: <strong>{{ selectedObject.DataAnulare |
                                DataOraFaraSec }}</strong>
                            </p>
                            <p class="rand-info">Motiv anulare: <strong>{{ selectedObject.MotivulAnularii }}</strong>
                            </p>
                        </div>
                    </el-card>
                </div>


            </div>

        </el-dialog>
        <Masini-dialog ref='masini_dlg' @save="salvare_masina" />
        <Clienti-dialog ref='clienti_dlg' @save="salvare_client" />
        <ajutor-montator-dialog ref='ajutor_montator_dlg' @save="adaugaAjutorMontator" />
    </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import SelectMasina from '@/components/SelectMasina'
import Masini_dialog from '@/pages/Admin/masini/Masini_dialog.vue';
import Clienti_dialog from '@/pages/Admin/clienti/Clienti_dialog.vue';
import TitluPagina from '@/widgets/TitluPagina';
import Calendar from '@/components/Calendar';
import moment from 'moment'
import ConfirmareSemnaturaFisa from '@/components/ConfirmareSemnaturaFisa'
import Ajutor_montator_dialog from "./Ajutor_montator_dialog.vue";

export default {
    name: "programari",
    extends: BasePage,
    components: {
        'base-page': BasePage,
        'titlu-pagina': TitluPagina,
        Calendar,
        SelectMasina,
        'Masini-dialog': Masini_dialog,
        'Clienti-dialog': Clienti_dialog,
        ConfirmareSemnaturaFisa,
        'ajutor-montator-dialog': Ajutor_montator_dialog
    },
    data() {

        let valideazaZiSiOraProgramare = async (rule, value, callback) => {

            if (this.selectedObject.ZiuaRezervarii == null && this.selectedObject.OraSelectata == null) {
                callback(new Error("Alege o zi"))
            } else if (this.selectedObject.OraSelectata == null) {
                callback(new Error("Alege o ora"))
            } else {
                value = new Date(this.selectedObject.ZiuaRezervarii + ' ' + this.selectedObject.OraSelectata)
            }

            if (value != null && moment(value).format('YYYY-MM-DD HH:mm') > moment().format('YYYY-MM-DD HH:mm')) {

            } else if (this.selectedObject.IdDeviz != null && this.selectedObject.AcordSemnat == true) {

            } else {
                callback(new Error("Data programarii trebuie sa fie dupa " + moment().format('YYYY-MM-DD HH:mm')))
            }

            if (this.selectedObject.OraSelectata > 0) {

                let OraProgrmare = this.selectedObject.OraSelectata + ':00';
                if (new Date(value).getDay() === 0) {
                    if (OraProgrmare >= this.Program.OraStartD && OraProgrmare <= this.Program.OraStopD)
                        callback();
                    else
                        callback(new Error("In ziua selectata programul de lucru este de la " + this.Program.OraStartD + " la " + this.Program.OraStopD))
                } else if (new Date(value).getDay() === 6) {
                    if (OraProgrmare >= this.Program.OraStartS && OraProgrmare <= this.Program.OraStopS)
                        callback();
                    else
                        callback(new Error("In ziua selectata programul de lucru este de la " + this.Program.OraStartS + " la " + this.Program.OraStopS))
                } else {
                    if (OraProgrmare >= this.Program.OraStartLV && OraProgrmare <= this.Program.OraStopLV)
                        callback();
                    else
                        callback(new Error("In ziua selectata programul de lucru este de la " + this.Program.OraStartLV + " la " + this.Program.OraStopLV))
                }
            }

        }
        return {
            OptiuneCantitati: null,
            idAjutorMontator: null,
            Hotel: 0,
            Reconditionare: 0,
            Returnare: 0,
            DepozitarePersonala: 0,
            DepozitareComanda: 0,
            DepozitareHotel: 0,

            dateCalendarVechi: '',
            trebuie_redirectionat_inapoi: '',
            scrollTop: null,
            Program: { SeLucreazaS: '1', SeLucreazaD: '0' },
            datePickerOptions: {
                firstDayOfWeek: 1,
                disabledDate: (date) => {
                    // inainte de ziua curenta nu se poate alege
                    if (date < new Date().setHours(0, 0, 0, 0)) {
                        return true
                    }

                    // daca hotel nu se poate alege o data anterioara
                    // if(this.selectedObject.Hotel == 1 && date < new Date(this.selectedObject.DataRezervariiInitiala).setHours( 0,0,0,0 ))  {
                    //     return true
                    // }
                    if (new Date(date).getDay() === 0 && this.Program.SeLucreazaD == 0) {
                        return true
                    } else if (new Date(date).getDay() === 6 && this.Program.SeLucreazaS == 0) {
                        return true
                    } else {
                        return false
                    }
                }
            },
            detaliiMasina: {},
            Results: [],
            base_url: '',
            Info: {
                ajutor_mecanici: [], mecanici: [], mecaniciCentru: [], mecaniciCentruDisponibili: [], montatori: [], masini: [], centreProductie: [], OreZi: [], clienti: [], marci: [], modele: []
            },
            loadingClients: false,
            Filters: {
                Marca: '-1', Model: '-1', Hotel: '-1', IdMecanic: '-1', Status: 'Deschisa', IdMasina: '-1', IdCentruProductie: '1', IdProgramare: '', Numar: '', IntervalOrar: ['06:00:00', '22:00:00'], IdClient: '', Telefon: '', interval: {}
            }, // de pus si masina in filtre?
            OrderBy: {},
            programari: [],
            selectedObject: { Hotel: '0', Cantitate: '1', Id: '-1', IdMecanic: '-1', IdMasina: '-1', DataRezervarii: '', ZiuaRezervarii: null, OraSelectata: null, DurataMin: 0, Observatii: '', IdClient: '', IdDeviz: '', IdCentruProductie: '1', IdServiciuProgramator: '' },
            IdMecanicNou: '',
            IdMontatorNou: '',
            showPopup: false,
            showInfoPopup: false,
            showPopupSchimbaMecanic: false,
            Utilizatori: [],
            raspuns: { Suprapune: [] },
            mode: 'add',
            numarMasina: '',
            arataInfoMasina: false,
            loading: false,
            loadingCalendar: false,
            dataCalendar: '',
            jantaAvariata: false,
            rules: {
                IdMasina: [{ required: true, message: "Campul este obligatoriu" }],
                IdMecanic: [{ required: true, message: "Campul este obligatoriu" }],
                IdServiciuProgramator: [{ required: true, message: "Campul este obligatoriu" }],
                ZiuaRezervarii: [{ required: true, validator: valideazaZiSiOraProgramare }],
                DurataMin: [{ required: true, message: "Campul este obligatoriu" }],
                Cantitate: [{ required: true, message: "Campul este obligatoriu" }],
            },
            fisaInCursDeSemnare: false,
            refresh: 0,
            refresh_interval: null,
            tagInputValue: '',
            tagInputVisible: false,
        }
    },
    methods: {

        showTagInput() {
            this.tagInputVisible = true
        },
        handleTagInputConfirm() {
            let value = this.tagInputValue.trim()
            value = value.replace(/[^0-9]/g, '')   

            if (value) {
                if (!this.selectedObject.NumereComanda) {
                this.selectedObject.NumereComanda = []
                }

                if (this.selectedObject.NumereComanda.includes(value)) {
                    this.$message.error('Numărul de comandă există deja!')
                } else {
                    this.selectedObject.NumereComanda.push(value)
                }
            }

            this.tagInputVisible = false
            this.tagInputValue = ''
        },
        removeNumarComanda(tag) {
            this.selectedObject.NumereComanda = this.selectedObject.NumereComanda.filter(t => t !== tag)
        },

        goToOrder(tag) {
            window.open(`https://www.anvelope.ro/order/${tag}`, "_blank");
        },

        async handleIntervalChange(interval) {

            if (this.$route.name != 'rezervari') {
                return;
            }
            clearInterval(this.refresh_interval);
            this.Filters.interval = interval;
            this.refresh_info_without_loader();
            this.refresh_interval = setInterval(() => {
                if (this.$route.name == 'rezervari') {
                    this.refresh_info_without_loader();
                }
            }, 10000);
        },

        async marcaChangeHandler() {
            if (!this.Filters.Marca || this.Filters.Marca == '-1') {
                this.Info.modele = [];
                this.Filters.Model = '-1';
            }
            if (this.Filters.Marca) {
                const response = await this.post("receptie/rezervari/get_model_for_marca", { id_marca: this.Filters.Marca });
                if (response && response.modele) {
                    this.Info.modele = response.modele;
                } else {
                    this.Info.modele = [];
                    this.Filters.Model = '';
                }
            }

            await this.refresh_info();
        },
        verifica_hotel: function () {
            // console.log('verifica_hotel', this.DepozitareHotel, this.selectedObject.Hotel)
            if (this.DepozitareHotel > 0) {
                this.selectedObject.Hotel = 1;
                // console.log('Hotel setat la 1')
            } else {
                this.selectedObject.Hotel = 0;
            }
        },

        handle_id_programare_change: function () {
            this.Filters.IdProgramare = parseInt(this.Filters.IdProgramare.replace(/\D/g, ''))
            if (isNaN(this.Filters.IdProgramare)) this.Filters.IdProgramare = "";
            this.refresh_info();
        },

        checkDreptFisa: function () {
            if (this.$has_right('Receptie') && moment(this.selectedObject.DataRezervarii).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')) {
                return false; // daca e receptie si data programarii e in viitor nu il arat
            }
            return true;
        },

        handle_telefon_change: function () {
            this.Filters.Telefon = (this.Filters.Telefon.replace(/\D/g, ''))
            if (isNaN(this.Filters.Telefon)) this.Filters.Telefon = "";
            this.refresh_info();
        },

        select_hour: function (value, index) {
            if (!value.liber) {
                return;
            }
            this.selectedObject.OraSelectata = index;
            ++this.refresh
        },

        generare_pdf(id_deviz) {
            let isDev = '';
            if (LocalSettings.IS_DEV) { isDev = '/dev' }
            window.open(isDev + "/#/fisa_pdf/" + id_deviz, '_blank');
            // window.open("/#/fisa_pdf/" + id_deviz, '_blank');
        },

        closeMe() {
            // this.$refs['my-form'].resetFields()
            this.semnaturaAcordata = false;
            this.fisaInCursDeSemnare = false;
            this.showPopup = false;
            this.detaliiMasina = {};
            this.arataInfoMasina = false;
            this.$emit("close");

            this.refresh_info();
        },
        neSemnat() {
            // this.refresh_info();
        },
        setCalendar() {

            console.log('S-a modificat lista programarilor! Refresh!')

            if (this.Results != undefined && this.Results.length > 0) {
                this.Results.forEach((r, index) => {
                    r.id = r.Id

                    if (r.StatusDeviz == 'Anulat' || r.Status == 'Anulata') {
                        r.eventBackgroundColor = '#F54242' // rosu
                        r.color = '#F54242'
                    }
                    if (r.StatusDeviz == 'Draft') {
                        r.eventBackgroundColor = '#FFB366' // portocaliu
                        r.color = '#FFB366'
                    }
                    if (r.StatusDeviz == 'Deschisa') {
                        r.eventBackgroundColor = '#4DD2FF' // bleu
                        r.color = '#4DD2FF'
                    }
                    if (r.StatusDeviz == 'Facturat') {
                        r.eventBackgroundColor = '#07AA6D' // verde
                        r.color = '#07AA6D'
                    }

                    if (r.StatusDeviz == 'Nefacturat') {
                        r.eventBackgroundColor = '#9b69c2' // mov
                        r.color = '#9b69c2'
                    }

                    if (r.StatusDeviz == 'Lipsa operatiune') {
                        r.eventBackgroundColor = '#f542c2' // roz
                        r.color = '#f542c2'
                    }
                    let eHotel = '';
                    let eComanda = '';
                    if (r.EsteHotel == 1){
                        eHotel = ' H';
                    } 

                    if (r.EsteComanda == 1){
                        eComanda = ' C';
                    } 
                    r.masina =
                        r.title = ' ' + r.Numar + ' #' + r.Id + ' - ' + r.Mecanic + eHotel + eComanda;
                    r.start = moment(r.DataRezervarii).format('YYYY-MM-DD HH:mm')
                    r.end = moment(r.DataRezervarii).add(r.DurataMin, "minutes").format('YYYY-MM-DD HH:mm')
                })
            }
        },

        handleDateSelect(selectInfo) {
            let title = prompt('Please enter a new title for your event')
            let calendarApi = selectInfo.view.calendar
            calendarApi.unselect() // clear date selection
            if (title) {
                calendarApi.addEvent({
                    id: createEventId(),
                    title,
                    start: selectInfo.startStr,
                    end: selectInfo.endStr,
                    allDay: selectInfo.allDay
                })
            }
        },

        handleChangeCantitate() {

            let servSelectat = this.Info.serviciiProgramator.find(serv => serv.Id === this.selectedObject.IdServiciuProgramator)
            if (servSelectat.IdCentruProductie != this.Filters.IdCentruProductie) {
                this.Filters.IdCentruProductie = servSelectat.IdCentruProductie;
                this.handleSchimbaZiua();
            }
            if (servSelectat && this.selectedObject.Cantitate > 0) {
                this.selectedObject.DurataMin = servSelectat.DurataServiciu / 60 * this.selectedObject.Cantitate;
                this.getSloturiDisponibile();
            }
            this.OptiuneCantitati = servSelectat.OptiuneCantitati;
        },

        async handleSchimbaZiua() {

            if (this.selectedObject.Hotel == 1 && new Date(this.selectedObject.ZiuaRezervarii).setHours(0, 0, 0, 0) < new Date(this.selectedObject.DataRezervariiInitiala).setHours(0, 0, 0, 0)) {

                await this.$confirm('Aceasta programare este de tip Hotel! Sunteti sigur ca vreti sa devansati programarea?', 'Atentie!', {
                    type: 'danger',
                    cancelButtonText: 'Anuleaza',
                }).then(async () => {
                }).catch(() => {
                    this.selectedObject.ZiuaRezervarii = moment(this.selectedObject.DataRezervariiInitiala).format("YYYY-MM-DD")
                });

            }

            var response = await this.post("receptie/rezervari/get_mecanici_disponibili_zi", { idCentruProductie: this.Filters.IdCentruProductie, zi: this.selectedObject.ZiuaRezervarii });
            if (response) {
                this.Info.mecaniciCentru = response.mecaniciDisponibiliInZi;
                let exista_mecanicul_in_zi = this.Info.mecaniciCentru.filter((item) => item.IdUtilizator == this.selectedObject.IdMecanic);
                if (exista_mecanicul_in_zi.length == 0) this.selectedObject.IdMecanic = "-1";

            }

            this.getSloturiDisponibile();

        },

        async getSloturiDisponibile() {


            if (this.selectedObject.IdServiciuProgramator == null || this.selectedObject.IdServiciuProgramator == '') return;

            if (this.selectedObject.ZiuaRezervarii < moment().format("YYYY-MM-DD")) return; // nu face request daca programarea e din trecut

            this.selectedObject.OraSelectata = moment(this.selectedObject.DataRezervarii).format("HH:mm");

            if (isNaN(this.selectedObject.DurataMin)) this.selectedObject.DurataMin = 20; // TBD daca din diverse motive nu exista intervalul atunci se pune default 20;

            var response = await this.post("receptie/rezervari/get_sloturi_disponibile_zi", { programare: this.selectedObject });
            if (this.selectedObject.OraSelectata != null &&
                (typeof response.intervale[this.selectedObject.OraSelectata] == 'undefined')) {
                this.selectedObject.OraSelectata = null;
            }

            if (this.mode == 'add') {
                this.selectedObject.OraSelectata = null;
            }

            // setTimeout(() => {
            //     this.Info.OreZi = response.intervale;
            // }, 2500)


            this.Info.OreZi = response.intervale;
        },

        async get_info() {

            var setari = await this.post("admin/setari/index");

            this.Program = setari.Setari;

            var response = await this.post("receptie/rezervari/get_info_calendar");
            this.Info.serviciiProgramatorToate = response.serviciiProgramator;
            this.Info.serviciiProgramator = response.serviciiProgramator;
            this.Info.mecanici = response.mecanici;
            this.Info.ajutor_mecanici = response.ajutor_mecanici;
            this.Info.mecaniciToateCentrele = response.mecaniciToateCentrele;
            this.Info.marci = response.marci;

            this.Info.centreProductie = response.centreProductie;
            // this.Info.masini                    = response.masini;          
            // this.Info.clienti                   = response.clienti;          
            this.refresh_info();
        },
        async searchClients(query) {
            if (!query) {
                this.Info.clienti = [];
                return;
            }
            this.loadingClients = true;

            try {
                var result = await this.post("receptie/rezervari/search_client", {
                    query: query,
                });

                this.Info.clienti = result.clienti;
            } catch (error) {
                console.error("Error fetching clients:", error);
            } finally {
                this.loadingClients = false;
            }
        },
        async refresh_info_without_loader() {

            var response = await this.post("receptie/rezervari/index", { Filters: this.Filters });
            if (typeof response.Results != 'undefined') {

                if (this.dateCalendarVechi != '' && JSON.stringify(response.Results) == this.dateCalendarVechi) {
                    console.log('nu s-a schimbat nimic in programari')
                } else {
                    this.Results = response.Results;
                    this.dateCalendarVechi = JSON.stringify(response.Results)
                    this.setCalendar()
                }
            }
        },

        async refresh_info() {

            if (this.$route.name != 'rezervari') {
                return;
            }

            this.loadingCalendar = true
            var response = await this.post("receptie/rezervari/index", { Filters: this.Filters });
            if (typeof response.Results != 'undefined') this.Results = response.Results;

            this.Info.serviciiProgramator = this.Info.serviciiProgramatorToate.filter((item) => item.IdCentruProductie == this.Filters.IdCentruProductie);

            if (this.showPopup == false) // doar daca nu e dialogul deschis
                this.Info.mecaniciCentru = this.Info.mecaniciToateCentrele.filter((item) => item.IdCentruProductie == this.Filters.IdCentruProductie);
            else {
                this.handleSchimbaZiua();
                // this.getSloturiDisponibile();
            }

            if (this.$route.name == 'rezervari') this.select_menu_item('rezervari');

            this.dateCalendarVechi = JSON.stringify(this.Results)
            this.setCalendar()
            this.loadingCalendar = false;
        },

        async reset() {
            // this.Filters = { Hotel: '-1' ,IdMecanic: '-1' , Status: 'Deschisa', IdMasina: '-1', IdCentruProductie: '1', IdProgramare: '', Numar: '', IntervalOrar: ['06:00:00', '22:00:00'], IdClient: '' , Telefon: '', interval: {} };  
            this.Filters.Marca = '-1';
            this.Filters.Model = '-1';
            this.Filters.Hotel = '-1';
            this.Filters.IdMecanic = '-1';
            this.Filters.Status = 'Deschisa';
            this.Filters.IdMasina = '-1';
            this.Filters.IdCentruProductie = '1';
            this.Filters.IdProgramare = '';
            this.Filters.Numar = '';
            this.Filters.IntervalOrar = ['06:00:00', '22:00:00'];
            this.Filters.IdClient = '';
            this.Filters.Telefon = '';
            // this.Filters.interval = {};

            await this.refresh_info();
        },

        async delete_item() {
            this.$prompt(`Va rugam sa introduceti motivul anularii`, 'Anuleaza programarea', {
                cancelButtonText: "Renunta",
                // pattern:/[A-Za-z0-9]{1,20}/
                inputPattern:
                    /[A-Za-z0-9]/,
                inputErrorMessage: 'Campul este obligatoriu',
            }).then(async (motiv) => {
                let res = await this.post("receptie/rezervari/anuleaza", { id: this.selectedObject.Id, motiv: motiv.value });
                await this.refresh_info();
                this.showPopup = false
                if (res.success && res.sms_sent) {
                    this.$message({ type: 'success', message: 'Anulare efectuata cu succes' });
                } else if(res.success && !res.sms_sent){
                    this.$message({
                        type: "warning",
                        message: "Programarea a fost anulata cu succes, dar SMS-ul nu a fost trimis catre client (" + res.sms_error + ')',
                        duration: 8000
                    })
                }else {
                    this.$message({ type: 'warning', message: 'Anularea nu a putut fi efectuata' });
                }
            }).catch(() => {
                this.$message({ type: 'info', message: 'Programarea nu a fost anulata' });
            });
        },

        async reprogrameaza() {

            this.showInfoPopup = false;
            this.mode = "add";

            this.selectedObject.Status = "Deschisa";
            this.selectedObject.IdMecanic = "-1";
            this.selectedObject.Id = "";
            this.selectedObject.DataRezervarii = "";
            this.selectedObject.ZiuaRezervarii = "";

            this.show_dialog(-33);
        },

        async programeaza_client(client, masina) {

            await this.select_masina(masina);
            this.mode = "add";

            this.selectedObject.IdMasina = masina.Id;
            this.selectedObject.Status = "Deschisa";
            this.selectedObject.IdMecanic = "-1";
            this.selectedObject.Id = "";
            this.selectedObject.IdClient = client.Id;
            this.selectedObject.ZiuaRezervarii = "";

            this.show_dialog(-34);


        },

        async programeaza_masina(masina, ultima_ruta) {

            this.trebuie_redirectionat_inapoi = ultima_ruta;

            await this.select_masina(masina);
            this.mode = "add";

            this.selectedObject.IdMasina = masina.Id;
            this.selectedObject.Status = "Deschisa";
            this.selectedObject.IdMecanic = "-1";
            this.selectedObject.Id = "";
            this.selectedObject.IdClient = masina.IdClient;
            this.selectedObject.ZiuaRezervarii = "";

            this.show_dialog(-35);

        },

        async verifica_montator_apoi_fisa() {
            try {



                // daca rezervarea nu are ajutor montator eroare
                // if (!this.selectedObject.IdAjutorMontator >0 || !this.selectedObject.IdAjutorMontator == -1) {
                //     this.$message({ type: 'error', message: 'Nu s-a selectat un ajutor montator pentru programare!' });
                //     return;
                // }
                this.genereaza_fisa();

                return;

                this.idAjutorMontator = null;

                const response = await this.post("receptie/rezervari/verifica_montator", { IdProgramare: this.selectedObject.Id });
                if (response && response.montator_disponibil) {
                    this.genereaza_fisa();
                    this.idAjutorMontator = response.montator_id;
                } else {
                    this.$message({ type: 'error', message: 'Ajutorul montator pentru mecanicul desemnat nu este disponibil, alege altul!' });
                    this.$refs.ajutor_montator_dlg.show_me(response.montatori_disponibili)
                }
            } catch (e) {
                console.error("Eroare la verificarea montatorului:", e);
                this.$message({ type: 'error', message: 'A aparut o eroare la verificarea montatorului!' });
            }
        },

        adaugaAjutorMontator(idAjutorMontator) {
            this.idAjutorMontator = idAjutorMontator;
            this.genereaza_fisa();
        },

        async genereaza_fisa(confirmat = 0) {
            if(!await this.verifica_sursa_destinatie()) {
                console.log('verifica_sursa_destinatie a returnat false, nu se genereaza fisa');
                return;
            }

            // salvez sursa si destinatie
            let date_suplimentare = {};
            if(this.OptiuneCantitati == 'sursa_destinatie'){
                date_suplimentare = {
                    Hotel: this.selectedObject.Hotel,
                    Reconditionare: this.Reconditionare,
                    Returnare: this.Returnare,
                    DepozitarePersonala: this.DepozitarePersonala,
                    DepozitareComanda: this.DepozitareComanda,
                    DepozitareHotel: this.DepozitareHotel,
                };
                
            }


            var response = await this.post("receptie/rezervari/fisa_noua", { IdProgramare: this.selectedObject.Id, confirmaMutarea: confirmat, date_suplimentare: date_suplimentare });
            this.showPopup = false;
            this.refresh_info();

            if (response.TrebuieConfirmare == 1) {
                // dau mesaj ca programarea este din viitor si cer confirmare ca este sigur ca vrea, apoi trimit din nou requestul
                this.$confirm('Programarea nu este din ziua curenta. Se va muta acum. Sunteti sigur ca doriti sa continuati?', 'Atentie!', {
                    confirmButtonText: 'Da',
                    cancelButtonText: 'Nu',
                    type: 'warning'
                }).then(async () => {
                    await this.genereaza_fisa(1);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Fisa nu a fost generata'
                    });
                });
                return;
            }

            if (typeof response.Deviz != 'undefined' && response.Deviz.Id > 1) {
                this.$refs['confirmareSemnatura'].getContent(response.Deviz.Id, this.idAjutorMontator)
            } else if (response.Error) {
                this.$message({ type: 'error', message: response.Error });
            }
        },

        async get_mecanici_disponibili() {
            var response = await this.post("receptie/rezervari/get_mecanici_disponibili", { IdProgramare: this.selectedObject.Id });
            // if(response.mecanici_list != ''){
            this.Info.mecaniciCentruDisponibili = response.mecanici_list;
            this.Info.montatori = response.montatori;
            this.showPopupSchimbaMecanic = true
            // }                    
        },

        async adauga_produse() {
            this.$router.push({ name: 'programare_produse', params: { id_programare: this.selectedObject.Id } })
        },

        getNumWorkDays(startDate, endDate) {
            var numWorkDays = 0;
            var currentDate = new Date(startDate);

            Date.prototype.addDays = function () {
                var date = new Date(this.valueOf());
                date.setDate(date.getDate() + 1);
                return date;
            };

            currentDate = currentDate.addDays(1);

            while (currentDate <= new Date(endDate)) {
                // Skips Sunday and Saturday
                if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
                    numWorkDays++;
                }
                currentDate = currentDate.addDays(1);
            }
            return numWorkDays;
        },



        notifica_depozitare() {

            // var diffInMinutes =  moment(this.selectedObject.DataRezervarii).diff(moment(), 'hours');

            var dif = this.getNumWorkDays(moment().format("YYYY-MM-DD") + " 23:59:59", this.selectedObject.DataRezervarii);

            if (dif < 2) {
                var textDialog = 'Sunt mai putine zile decat cele pentru o comanda cu anvelope depozitate . Sigur doresti sa continui?';
                var tipDialog = 'warning';

            } else {
                var textDialog = 'Deschide un tichet pentru anvelope?';
                var tipDialog = 'info';
            }

            this.$confirm(textDialog, 'Deschidere tichet hotel', {
                type: tipDialog,
                cancelButtonText: 'Anuleaza',
            }).then(async () => {
                await this.trimite_mail_depozitare();
            }).catch(() => {
            });

        },

        async trimite_mail_depozitare() {

            var response = await this.post("receptie/rezervari/trimite_mail_depozitare", { IdProgramare: this.selectedObject.Id });

            if (response.Sucess != '' && !response.Error) {
                this.$message({ type: 'success', message: 'A fost trimis un email catre depozitare@anvelope.ro!' });
                this.selectedObject.Hotel = '1';
            } else {
                this.$message({ type: 'error', message: 'A aparut o problema!' });
            }
        },

        async schimba_mecanic() {

            var response = await this.post("receptie/rezervari/schimba_mecanic", { IdProgramare: this.selectedObject.Id, IdMecanicNou: this.IdMecanicNou, IdMontatorNou: this.IdMontatorNou });

            if (response.Sucess != '' && !response.Error) {
                this.$message({ type: 'success', message: response.Success });
                this.IdMecanicNou = '';
                this.IdMontatorNou = '';
                this.showPopupSchimbaMecanic = false;

                this.get_programare(this.selectedObject.Id)
                this.refresh_info();

            } else {
                this.$message({ type: 'error', message: response.Error });
            }
        },

        async schimba_observatiile() {

            var response = await this.post("receptie/rezervari/schimba_observatiile", { IdProgramare: this.selectedObject.Id, Observatii: this.selectedObject.Observatii });

            if (response.Sucess != '' && !response.Error) {
                this.selectedObject.ObservatiiInitiale = this.selectedObject.Observatii;
                this.refresh_info();
                this.$message({ type: 'success', message: response.Success });
            } else {
                this.$message({ type: 'error', message: 'Eroare' });
            }
        },

        async show_dialog(id) {

            this.loading = false
            this.idAjutorMontator = null;

            if (id >= -1) {
                this.numarMasina = ''
                this.selectedObject.Id = id
                this.selectedObject.Cantitate = 1
                this.selectedObject.DurataMin = 30
                this.selectedObject.DataRezervarii = '';
                // this.selectedObject.IdMecanic   = this.Filters.IdMecanic
                this.selectedObject.IdClient = ''
                this.selectedObject.IdServiciuProgramator = ''
                this.selectedObject.IdDeviz = ''
                this.selectedObject.IdMasina = ''
                this.selectedObject.Hotel = '0'
                this.selectedObject.Observatii = ''
                this.selectedObject.AcordSemnat = ''
                this.selectedObject.IdCentruProductie = this.Filters.IdCentruProductie;
                this.raspuns = {};
            }
            // this.showPopup                  = true
            this.mode = 'add'
            if (id > -1) {
                this.Info.OreZi = [];
                this.selectedObject.hasDeviz = false;
                this.get_programare(id)
                this.$nextTick(() => {
                    if (this.$refs.destinatieAnvelopeCard) {
                        this.$refs.destinatieAnvelopeCard.fetchDestinatieAnvelope();
                    }
                });
                this.mode = 'edit'
                this.arataInfoMasina = true
            } else {
                this.handleSchimbaZiua();
                this.showPopup = true
                this.resetDestinatieAnvelope();
                this.resetSursaAnvelope();
                this.arataInfoMasina = false
            }
        },

        async show_info_dialog() {
            this.showInfoPopup = true;
        },

        async select_masina(item) {
            // console.log('select_masina', item);
            this.arataInfoMasina = true;
            this.numarMasina = item.Numar;
            this.detaliiMasina = item;
            this.selectedObject.IdClient = item.IdClient;
        },

        async salvare_masina() {
            this.get_info();
            var response = await this.post('receptie/rezervari/get_last_masina', { idMasina: this.selectedObject.IdMasina })
            this.selectedObject.IdMasina = response.LastCarId
            this.selectedObject.IdClient = response.detaliiMasina.IdClient
            this.numarMasina = response.NumarMasina
            this.detaliiMasina = response.detaliiMasina

            // s-a salvat masina, trebuie actualizat idClient din programare
            if (this.selectedObject.Id > 0) {
                let res = await this.post('receptie/rezervari/schimba_client_masina_programare', { programare: this.selectedObject })
                this.selectedObject.IdClient = res.IdClient;
            }
        },

        async salvare_client() {
            var response = await this.post('receptie/rezervari/get_last_masina', { idMasina: this.selectedObject.IdMasina });
            this.detaliiMasina = response.detaliiMasina
        },

        async get_programare(id) {
            var result = await this.post("receptie/rezervari/get_programare", { id: id });

            this.jantaAvariata = false;
            this.detaliiMasina = result.Programare.detaliiMasina;
            this.selectedObject = result.Programare;
            this.selectedObject.suprapune = result.suprapune;
            this.selectedObject.ZiLiberaSauLipsaProgram = result.ZiLiberaSauLipsaProgram;
            this.numarMasina = result.Programare.NumarMasina;

            this.selectedObject.DataRezervariiInitiala = result.Programare.DataRezervarii;
            this.selectedObject.Hotel = result.Programare.Hotel;
            this.selectedObject.IdMecanicInitial = result.Programare.IdMecanic;
            this.selectedObject.IdClient = result.Programare.IdClient;
            this.selectedObject.ObservatiiInitiale = this.selectedObject.Observatii;
            this.selectedObject.idAjutorMontator = result.Programare.IdAjutorMontator;
            this.selectedObject.hasDeviz = result.Programare.hasDeviz;
            // console.log(this.selectedObject.idAjutorMontator);

            let exista = false;
            if (this.selectedObject.Deviz && this.selectedObject.Deviz.StareRoti) {
                const stareRotiDecoded = JSON.parse(this.selectedObject.Deviz.StareRoti);
                stareRotiDecoded.forEach((stare) => {
                    if (stare.hasOwnProperty('janta_avariata')) {
                        exista = true;
                    }
                })
            }

            if (exista) {
                this.jantaAvariata = true;
            } else {
                this.jantaAvariata = false;
            }

            if (result.Programare.Status == 'Anulata'
                || (typeof result.Programare.Deviz != 'undefined' && result.Programare.Deviz.Status == 'Facturat')
                || (typeof result.Programare.Deviz != 'undefined' && result.Programare.Deviz.Status == 'Aprobat')
                || (typeof result.Programare.Deviz != 'undefined' && result.Programare.Deviz.Status == 'Lipsa operatiune')
            ) {
                if (typeof this.selectedObject.Deviz == 'object') {
                    if (typeof this.selectedObject.Deviz.StareRotiFiltrat == 'object')
                        this.selectedObject.Deviz.StareRotiFiltrat = JSON.parse(this.selectedObject.Deviz.StareRoti).filter((value) => value.index != null);

                }

                this.show_info_dialog();
                return

            }

            this.selectedObject.OraSelectata = moment(this.selectedObject.DataRezervarii).format("HH:mm")
            this.selectedObject.ZiuaRezervarii = moment(this.selectedObject.DataRezervarii).format("YYYY-MM-DD")


            // this.selectedObject.Deviz = 

            // daca mecanicul nu mai este disponibil in ziua selectata trebuie adaugat fortat in select
            if (typeof this.selectedObject.ZiLiberaSauLipsaProgram != 'undefined') {

                let exista_mecanicul_in_zi = this.Info.mecaniciCentru.filter((item) => item.IdUtilizator == this.selectedObject.IdMecanic);

                if (exista_mecanicul_in_zi.length > 0) {
                    if (exista_mecanicul_in_zi[0].Nume.slice(-16) != '( Indisponibil )') exista_mecanicul_in_zi[0].Nume += '( Indisponibil )';
                } else {
                    let exista_mecanicul_in_tot = { ...this.Info.mecaniciToateCentrele.filter((item) => item.IdUtilizator == this.selectedObject.IdMecanic && item.IdCentruProductie == this.Filters.IdCentruProductie) };

                    if (Object.keys(exista_mecanicul_in_tot).length >= 1) {
                        if (exista_mecanicul_in_tot[0].Nume.slice(-16) != '( Indisponibil )') {
                            exista_mecanicul_in_tot[0].Nume += '( Indisponibil )';
                        }
                        this.Info.mecaniciCentru.push(exista_mecanicul_in_tot[0]);
                    }
                }

                this.getSloturiDisponibile();
            } else {
                // console.log('mecanicul este disponibil in ziua selectata')
                this.handleSchimbaZiua()
            }

            this.resetDestinatieAnvelope();
            this.resetSursaAnvelope();
            
            let servSelectat = this.Info.serviciiProgramator.find(serv => serv.Id === this.selectedObject.IdServiciuProgramator)
            this.OptiuneCantitati = servSelectat.OptiuneCantitati;

            if(this.OptiuneCantitati == 'sursa_destinatie') {

                await this.fetchDestinatieAnvelope();
                await this.fetchSursaAnvelope();
            }

            

            this.showPopup = true;
            // } else{
            //     this.showPopup                  = false;
            // }
        },

        resetDestinatieAnvelope() {
            this.Reconditionare = 0;
            this.Hotel = 0;
            this.Returnare = 0;
        },
        resetSursaAnvelope() {
            this.DepozitarePersonala = 0;
            this.DepozitareComanda = 0;
            this.DepozitareHotel = 0;
        },
        async verifica_sursa_destinatie() {

            if (this.OptiuneCantitati === 'sursa_destinatie') {
                const cantitateRezervare = Number(this.selectedObject?.Cantitate) || 0;
                const total_destinatie = Number(this.Hotel || 0) + Number(this.Reconditionare || 0) + Number(this.Returnare || 0);

                if (total_destinatie !== cantitateRezervare) {
                    if (total_destinatie > cantitateRezervare && total_destinatie <= cantitateRezervare * 2) {
                        try {
                            await this.$confirm(
                                'Cantitatea destinatie este mai mare decat cantitatea rezervarii. Continuati?',
                                'Atentie!',
                                { type: 'warning', cancelButtonText: 'Anuleaza' }
                            );
                            // dacă dă OK → continuăm
                        } catch {
                            this.$message({ type: 'error', message: 'Operatiunea a fost anulata!' });
                            return false;
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: 'Cantitatea nu corespunde cu totalul cantitatilor introduse in destinatia anvelopelor!'
                        });
                        return false;
                    }
                }

                const sursaTotal = Number(this.DepozitarePersonala || 0) + Number(this.DepozitareComanda || 0) + Number(this.DepozitareHotel || 0);

                if (sursaTotal !== cantitateRezervare) {
                    if (sursaTotal > cantitateRezervare && sursaTotal <= cantitateRezervare * 2) {
                        try {
                            await this.$confirm(
                                'Cantitatea sursa este mai mare decat cantitatea rezervarii. Continuati?',
                                'Atentie!',
                                { type: 'warning', cancelButtonText: 'Anuleaza' }
                            );
                        } catch {
                            this.$message({ type: 'error', message: 'Operatiunea a fost anulata!' });
                            return false;
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: 'Cantitatea nu corespunde cu totalul cantitatilor introduse in sursa anvelopelor!'
                        });
                        return false;
                    }
                }
            } else {
                this.resetDestinatieAnvelope();
                this.resetSursaAnvelope();
            }
            return true;
        },

        async verifica_sursa_destinatie_save(){
            if (this.OptiuneCantitati === 'sursa_destinatie') {
                const cantitateRezervare = Number(this.selectedObject?.Cantitate) || 0;
                const total_destinatie_front = Number(this.Hotel || 0) + Number(this.Reconditionare || 0) + Number(this.Returnare || 0);
                const total_sursa_front = Number(this.DepozitarePersonala || 0) + Number(this.DepozitareComanda || 0) + Number(this.DepozitareHotel || 0);
                const response_cantitati = await this.post("receptie/rezervari/get_cantitati_anvelope", {
                    IdRezervare: this.selectedObject.Id,
                });

                let total_destinatie_db = 0;
                let total_sursa_db = 0;

                if(response_cantitati && response_cantitati.total_destinatie_db && response_cantitati.total_sursa_db){
                    total_destinatie_db = response_cantitati.total_destinatie_db;
                    total_sursa_db = response_cantitati.total_sursa_db;
                }

                if ((total_destinatie_front !== total_destinatie_db) && (total_sursa_front !== total_sursa_db)) {
                    try {
                        await this.$confirm(
                            'Cantitatea destinatie si cantitatea sursa au fost modificate. Salvati?',
                            'Atentie!',
                            { type: 'warning', cancelButtonText: 'Anuleaza' }
                        );
                    } catch {
                        this.$message({ type: 'error', message: 'Cantitatile nu au fost modificate!' });
                        return false;
                    }
                }else if(total_destinatie_front !== total_destinatie_db){
                    try {
                        await this.$confirm(
                            'Cantitatea destinatie a fost modificata. Salvati?',
                            'Atentie!',
                            { type: 'warning', cancelButtonText: 'Anuleaza' }
                        );
                    } catch {
                        this.$message({ type: 'error', message: 'Cantitatile nu au fost modificate!' });
                        return false;
                    }
                }else if(total_sursa_front !== total_sursa_db){
                    try {
                        await this.$confirm(
                            'Cantitatea sursa a fost modificata. Salvati?',
                            'Atentie!',
                            { type: 'warning', cancelButtonText: 'Anuleaza' }
                        );
                    } catch {
                        this.$message({ type: 'error', message: 'Cantitatile nu au fost modificate!' });
                        return false;
                    }
                }

                if ((total_destinatie_front > cantitateRezervare && total_destinatie_front <= cantitateRezervare * 2) && (total_sursa_db > cantitateRezervare && total_sursa_db <= cantitateRezervare * 2)) {
                    try {
                        await this.$confirm(
                            'Cantitatea destinatie si cantitatea sursa sunt mai mari decat cantitatea rezervarii. Continuati?',
                            'Atentie!',
                            { type: 'warning', cancelButtonText: 'Anuleaza' }
                        );
                    } catch {
                        this.$message({ type: 'error', message: 'Cantitatile nu au fost modificate!' });
                        return false;
                    }
                }else if(total_destinatie_front > cantitateRezervare && total_destinatie_front <= cantitateRezervare * 2){
                    try {
                        await this.$confirm(
                            'Cantitatea destinatie este mai mare decat cantitatea rezervarii. Continuati?',
                            'Atentie!',
                            { type: 'warning', cancelButtonText: 'Anuleaza' }
                        );
                    } catch {
                        this.$message({ type: 'error', message: 'Cantitatile nu au fost modificate!' });
                        return false;
                    }
                }else if(total_sursa_front > cantitateRezervare && total_sursa_front <= cantitateRezervare * 2){
                    try {
                        await this.$confirm(
                            'Cantitatea sursa este mai mare decat cantitatea rezervarii. Continuati?',
                            'Atentie!',
                            { type: 'warning', cancelButtonText: 'Anuleaza' }
                        );
                    } catch {
                        this.$message({ type: 'error', message: 'Cantitatile nu au fost modificate!' });
                        return false;
                    }
                }
            } else {
                this.resetDestinatieAnvelope();
                this.resetSursaAnvelope();
            }
            return true;
        },
        async fetchDestinatieAnvelope() {
            try {
                const response = await this.post("receptie/rezervari/get_destinatie_anvelope", {
                    IdProgramare: this.selectedObject.Id,
                });

                if (Array.isArray(response.destinatie_anvelope) && response.destinatie_anvelope.length > 0) {
                    const destinatie = response.destinatie_anvelope[0];

                    this.Reconditionare = parseInt(destinatie.Reconditionare) || 0;
                    this.Hotel = parseInt(destinatie.Hotel) || 0;
                    this.Returnare = parseInt(destinatie.Returnare) || 0;
                }

            } catch (error) {
                console.error("Error fetching destinatie anvelope:", error);
            }
        }, 
        async fetchSursaAnvelope() {
            try {
                const response = await this.post("receptie/rezervari/get_sursa_anvelope", {
                    IdProgramare: this.selectedObject.Id,
                });

                if (Array.isArray(response.sursa_anvelope) && response.sursa_anvelope.length > 0) {
                    const destinatie = response.sursa_anvelope[0];

                    this.DepozitarePersonala = parseInt(destinatie.CantDepozitarePersonala) || 0;
                    this.DepozitareComanda = parseInt(destinatie.CantDepozitareComanda) || 0;
                    this.DepozitareHotel = parseInt(destinatie.CantDepozitareHotel) || 0;
                }

            } catch (error) {
                console.error("Error fetching sursa anvelope:", error);
            }
        },

        save: async function () {
            this.$refs['my-form'].validate(async (valid) => {
                if (valid) {
                    let modifica_cantitati = true;
                    if(!await this.verifica_sursa_destinatie_save()) {
                        modifica_cantitati = false;
                    };
                    this.selectedObject.DataRezervarii = this.selectedObject.ZiuaRezervarii + ' ' + this.selectedObject.OraSelectata + ':00';
                    this.loading = true
                    const destinatieObj = this.prepareDestinatieAnvelope();
                    const sursaObj = {
                        DepozitarePersonala: this.DepozitarePersonala,
                        DepozitareComanda: this.DepozitareComanda,
                        DepozitareHotel: this.DepozitareHotel,
                    };
                    this.raspuns = await this.post("receptie/rezervari/save_programari_calendar", { mode: this.mode, object: this.selectedObject, Sursa: window.location.origin, destinatieAnvelope: destinatieObj, sursaAnvelope: sursaObj, modifica_cantitati });
                    this.loading = false
                    if (this.raspuns.Success && this.raspuns.sms_sent) {
                        this.selectedObject.OraSelectata = null;
                        this.$message({ type: 'success', message: 'Programarea a fost inregistrata' });
                        this.showPopup = false

                        if (this.trebuie_redirectionat_inapoi != '') {
                            this.$router.go(-1)
                        } else
                            this.refresh_info()

                    }else if(this.raspuns.Success && !this.raspuns.sms_sent){
                        this.showPopup = false
                        this.$message({ type: 'warning', message: "Programarea a fost inregistrata cu succes, dar SMS-ul nu a fost trimis catre client (" + this.raspuns.sms_error + ')',duration: 8000});
                        if (this.trebuie_redirectionat_inapoi != '') {
                            this.$router.go(-1)
                        } else{
                            this.refresh_info()
                        }
                    } else if (this.raspuns.Success == 0 && typeof this.raspuns.AnulataLa != 'undefined') {
                        this.selectedObject.OraSelectata = null;
                        this.$message({ type: 'error', message: this.raspuns.AnulataLa });
                        this.refresh_info()
                    } else if (this.raspuns.Success == 0 && typeof this.raspuns.Error == 'undefined') {
                        this.getSloturiDisponibile();
                    } else {
                        this.$message({ type: 'error', message: this.raspuns.Error });
                        this.refresh_info()
                    }
                }
            });
        },

        prepareDestinatieAnvelope() {
            return {
                Reconditionare: this.Reconditionare,
                Hotel: this.Hotel,
                Returnare: this.Returnare,
            }
        },

        programareNoua(data) {
            if (moment(data).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")) return; // nu deschide dialog pt zile precedente
            this.selectedObject.ZiuaRezervarii = moment(data).format("YYYY-MM-DD")
            this.selectedObject.IdMecanic = this.Filters.IdMecanic;
            this.selectedObject.DurataMin = 30;
            this.getSloturiDisponibile();
            this.show_dialog(-1)
        },

        editProgramare(obj) {
            var item = JSON.parse(obj)
            this.show_dialog(item.id)
        },

        adaugaMasina() {
            this.selectedObject.IdMasina = '';
            this.$refs.masini_dlg.show_me();
        },

        modificaMasina() {
            this.$refs.masini_dlg.show_me(this.selectedObject.IdMasina);
        },
        modificaClient() {
            this.$refs.clienti_dlg.show_me(this.selectedObject.IdClient);
        },
    },
    mounted() {
        if (this.$has_right('Mecanic') || this.$has_right('AjutorMontator')) {
            this.$router.push("/no-rights");
            return;
        }
        if (this.$route.query.open_id) {
            this.show_dialog(this.$route.query.open_id);
        }
        this.base_url = settings.BASE_URL;
    },

    created() {
        this.get_info();
    },

    beforeDestroy() {
        clearInterval(this.refresh_interval);
    }
};
</script>

<style lang="less">
@gri: #F1F2F2;
@albastru: #4C63E8;
@liber: #caffc4;
@liber_text: #185210;
@ocupat: #f3f5f9;
@ocupat_text: #b3bbca;









.main-container {
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1%;
    // height: 100vh !important;


    .half-container {
        // background-color: red;
        width: 49%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

    }
}

.tabelRandMic {
    .el-table__row td {
        padding: 1px !important;
        height: 20px !important;
    }
}

.rand-info {
    margin-bottom: 0px !important;
    font-size: small;
}

.ore {
    box-sizing: border-box;
    margin-top: 5%;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;

    p {
        font-size: 18px;
        width: 100%;
        text-align: center;
        border-bottom: 1px solid @gri;
        // line-height: 0.1em;
        margin: 10px 0 20px;
    }

    p .bara {
        background: #fff;
        padding: 0 10px;
    }

    p .data {
        color: @albastru;
        font-weight: 600;
    }

    .butoane {
        margin: 0 20px;
        max-width: 100%;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        .ora-selectata {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: @liber;
            color: @liber_text;
            margin: 3px;
            padding: 8px 3px;
            width: 83px;
            height: 31px;
            border-radius: 5px;
            border: 2px solid black;
        }

        .ora-selectata-ocupata {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: @ocupat;
            color: @ocupat_text;
            margin: 3px;
            padding: 8px 3px;
            width: 83px;
            height: 31px;
            border-radius: 5px;
            border: 2px solid black;
        }

        .liber {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: @liber;
            color: @liber_text;
            margin: 3px;
            padding: 8px 3px;
            width: 83px;
            height: 31px;
            border-radius: 5px;
        }

        .ocupat {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: @ocupat;
            color: @ocupat_text;
            margin: 3px;
            padding: 8px 3px;
            width: 83px;
            height: 31px;
            border-radius: 5px;
            cursor: not-allowed;
        }

        .liber:hover {
            border: 2px solid @liber_text;
            cursor: pointer;
        }

        .button-ora {
            margin: 3px;
            padding: 8px 3px;
            width: 83px;
            height: 31px;
            border-radius: 5px;
        }
    }
}


.buton-link {
    color: #67c23a;
    text-decoration: underline;
    margin-right: 10px;

}

.buton-link:hover {
    cursor: pointer;
}

.top50 {
    margin-top: 20px;
}

.filtre {
    .el-input-number {
        width: 100% !important;
    }
}

.input-prog {
    width: 25%;
}

.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    -webkit-box-align: stretch;
    align-items: stretch;
    width: 100%;

    .input-group-input {
        position: relative;
        -webkit-box-flex: 1;
        flex: 1 1 auto;
        width: 1%;
    }

    .input-group-append {
        margin-left: -1px;
        display: flex;
    }
}

.full-width {
    width: 100% !important;
}

.fc-daygrid-event-harness {
    a:hover {
        // TODO: facultativ
        background-color: #f0b737;
    }

    .fc-daygrid-event-dot {
        display: none;
    }

    .fc-event-time {
        margin-left: 5px;
    }
}


.fc-daygrid-event-harness {
    a:hover {
        // TODO: facultativ
        background-color: #f0b737;
    }

    .fc-daygrid-event-dot {
        display: none;
    }

    .fc-event-time {
        margin-left: 5px;
    }
}

@media only screen and (max-width: 700px) {
    .input-group-big {
        display: flex;
        flex-direction: column;
    }

    .dialog-footer {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        justify-content: center;

    }

    .el-card__body {
        margin: 0;
        padding: 10px 0;
    }

    .dialog-footer .el-button {
        margin: 0;
        width: 45%;
        margin-top: 5px;
        white-space: normal;
        word-wrap: break-word;
        font-size: 10.5px;

    }

    .input-prog {
        width: 100%;
    }

    .fc-header-toolbar {
        display: flex;
        flex-direction: column-reverse;
    }

    .fc-button {
        width: 45px;
        height: 45px;
        display: flex;
    }

    #fc-dom-1 {
        font-size: 20px;
    }

}

.el-tag {
    margin-right: 8px; 
    margin-bottom: 8px;
}
</style>